module.exports = __webpack_public_path__ + "static/media/teamThree.1efabc05.webp";